import { render } from "./InternetLinkPage.vue?vue&type=template&id=6fd59eeb&scoped=true&ts=true"
import script from "./InternetLinkPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./InternetLinkPage.vue?vue&type=script&lang=ts&setup=true"

import "./InternetLinkPage.vue?vue&type=style&index=0&id=6fd59eeb&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fd59eeb"],['__file',"src/pages/settings/pages/internetLink/InternetLinkPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6fd59eeb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6fd59eeb', __exports__)) {
    api.reload('6fd59eeb', __exports__)
  }
  
  module.hot.accept("./InternetLinkPage.vue?vue&type=template&id=6fd59eeb&scoped=true&ts=true", () => {
    api.rerender('6fd59eeb', render)
  })

}


export default __exports__